export default "__VITE_ASSET__uAsG4zzv__"